<template functional>
  <table class="info">
    <slot />
  </table>
</template>

<script>
export default {
    name: 'BaseTable',
};
</script>
